import { breakpoints, Button, theme } from '@notino/react-styleguide';

import { styled } from '@linaria/react';

export const DesktopHeader = styled.div`
  justify-content: space-between;
  align-items: center;
  padding: 24px;
  position: sticky;
  top: 0;
  z-index: 11;
  background-color: ${theme.color.background.primary};
  box-shadow: 0px 2px 4px 0px rgba(71, 71, 71, 0.08),
    0px 1px 2px 0px rgba(71, 71, 71, 0.04);

  display: none;
  @media (min-width: ${breakpoints.md}) {
    display: flex;
  }
`;

export const Wrapper = styled.div`
  padding: 1rem 1.25rem;
  @media (min-width: ${breakpoints.md}) {
    padding: 1.25rem 1.5rem;
  }
`;

export const StyledButton = styled(Button)`
  width: 100%;
  @media (min-width: ${breakpoints.md}) {
    width: auto;
    min-width: 180px;
  }
`;

export const StyledHeader = styled.div`
  ${theme.typography.labelLarge}
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  grid-area: buttons;
`;

export const StickyButtonsFooter = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10;
  background-color: ${theme.color.background.primary};
  box-shadow: 0px -2px 4px 0px rgba(71, 71, 71, 0.08),
    0px -1px 2px 0px rgba(71, 71, 71, 0.04);
  padding: 1rem 1.25rem;
  padding-bottom: calc(1rem + env(safe-area-inset-bottom));
  display: flex;
  flex-direction: column;
  gap: 8px;

  @media (min-width: ${breakpoints.md}) {
    position: sticky;
    left: auto;
    right: auto;
    padding: 1rem 1.5rem;
    flex-direction: row;
    justify-content: flex-end;
  }
`;

export const Grid = styled.div`
  display: grid;
  gap: 20px;
  grid-template-areas:
    'productInfo'
    'buttons'
    'voucherInfo';

  @media (min-width: ${breakpoints.md}) {
    grid-template-columns: 1fr auto;
    grid-template-areas:
      'productInfo buttons'
      'voucherInfo buttons';
  }
`;
